export interface TextMatch {
  tier: number // 0: equal or prefix, 1: somewhere in a row, 2: the letters in order with gaps
  ranges: [number, number][] // (matched index ranges in the text, to highlight)
}

// How `needle` (already lower case) matches `text`: a prefix (an equal text counts), then anywhere in a row, then,
// with `allowGaps`, as its letters in order with anything in between, the way the JetBrains project search does it
// (`socg` finds `SomeCoolTag`). Shared by the hashtag suggestions and the search of the list.
export function matchText(text: string, needle: string, allowGaps: boolean = true): TextMatch | null {
  const lower = text.toLowerCase()
  if (lower.startsWith(needle)) return { tier: 0, ranges: [[0, needle.length]] }
  const at = lower.indexOf(needle)
  if (at >= 0) return { tier: 1, ranges: [[at, at + needle.length]] }
  if (!allowGaps) return null
  const ranges: [number, number][] = []
  let position = 0
  for (const char of needle) {
    const found = lower.indexOf(char, position)
    if (found < 0) return null
    const last = ranges[ranges.length - 1]
    if (last && last[1] === found) last[1] = found + char.length
    else ranges.push([found, found + char.length])
    position = found + char.length
  }
  return { tier: 2, ranges }
}
